import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "TableVocabularies" }
const _hoisted_2 = { class: "min-w-full table-auto border-collapse border rounded-b-xl overflow-hidden shadow-sm bg-white" }
const _hoisted_3 = { class: "bg-gradient-to-br from-blue-500 to-gray-600 text-white" }
const _hoisted_4 = {
  key: 0,
  class: "px-4 py-2 text-left font-bold",
  id: "CHONTATCALUUVAOLOCALSTORAGEHOACXOACHONTATCA"
}
const _hoisted_5 = {
  key: 1,
  class: "px-4 py-2 text-left font-bold",
  id: "OPERATION"
}
const _hoisted_6 = {
  key: 0,
  id: "TABLE-BASIC",
  class: "table-body-vocabulary"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "px-4 py-2 text-left flex english" }
const _hoisted_9 = { class: "font-semibold text-blue-900 mr-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "px-4 py-2 text-left translate" }
const _hoisted_12 = { class: "px-2 py-2" }
const _hoisted_13 = { class: "flex items-center justify-end text-2xl text-blue-900" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = {
  key: 0,
  "aria-colspan": 3
}
const _hoisted_16 = {
  colspan: 3,
  class: "px-4 py-2 text-center text-gray-500"
}
const _hoisted_17 = {
  key: 1,
  id: "TABLE-PRACTICE",
  class: "table-body-vocabulary"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "px-4 py-2 text-left flex english" }
const _hoisted_20 = { class: "font-semibold text-blue-900 mr-2" }
const _hoisted_21 = { class: "px-4 py-2 text-left translate" }
const _hoisted_22 = { class: "px-2 py-2" }
const _hoisted_23 = { class: "flex items-center justify-end text-2xl text-blue-900" }
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = {
  key: 0,
  "aria-colspan": 3
}
const _hoisted_26 = {
  colspan: 3,
  class: "px-4 py-2 text-center text-gray-500"
}

import { ref, PropType, onMounted, watch } from "vue";
import { IVocabulary } from "@/models/IIearnEnglish";
import "ant-design-vue/dist/antd.css";
import { IPageInfo } from "@/models/base";

import PaginationComponent from "@/components/navigation/PaginationComponent.vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

import {
  StarOutlined,
  StarFilled,
  EllipsisOutlined,
} from "@ant-design/icons-vue";
import { getLoadingGet } from "@/utils/loadingUtils";
import i18n from "@/services/i18n";
import { Dropdown, Menu } from "ant-design-vue";
import DrawerVocaDetail from "./DrawerVocaDetail.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableVocabulariesComponent',
  props: {
  vocabularyList: {
    type: Array as () => Array<IVocabulary>,
    required: false,
  },
  pageInfo: {
    type: Object as PropType<IPageInfo<IVocabulary> | undefined>,
    required: false,
  },
  isSelectPractice: {
    type: Boolean,
  },
},
  emits: [
  "pageChange",
  "pageSizeChange",
  "changeSpecial",
  "delete",
  "edit",
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedVocabulary = ref<IVocabulary | null>(null);
const handlePageChange = (page: number) => {
  emit("pageChange", page);
};
const handlePageSizeChange = (current: number, pageSize: number) => {
  emit("pageSizeChange", { current, pageSize });
};
const handleChangeSpecial = (o: IVocabulary) => {
  emit("changeSpecial", o);
};
const handleDelete = (o: IVocabulary) => {
  emit("delete", o);
};
const handleEdit = (o: IVocabulary) => {
  emit("edit", o);
};

const drawerVisible = ref(false);
const handleRowClick = (record: IVocabulary) => {
  selectedVocabulary.value = record;
  drawerVisible.value = true;
};

const storedVocabularyIds = ref<number[]>([]);

const loadStoredVocabularies = () => {
  try {
    const raw = localStorage.getItem("selected_vocabularies");
    const stored: IVocabulary[] = raw ? JSON.parse(raw) : [];
    storedVocabularyIds.value = stored
      .map((v) => v.id)
      .filter(Boolean) as number[];
  } catch (e) {
    console.error("Lỗi đọc localStorage:", e);
    storedVocabularyIds.value = [];
  }
};

// Gọi lúc mounted
loadStoredVocabularies();

const toggleVocabularyInStorage = (record: IVocabulary) => {
  const storageKey = "selected_vocabularies";
  let stored: IVocabulary[] = [];

  try {
    const raw = localStorage.getItem(storageKey);
    stored = raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.error("Lỗi đọc localStorage:", e);
  }

  const exists = stored.some((v) => v.id === record.id);

  if (exists) {
    stored = stored.filter((v) => v.id !== record.id);
  } else {
    stored.push(record);
  }

  localStorage.setItem(storageKey, JSON.stringify(stored));
  loadStoredVocabularies(); // cập nhật danh sách sau khi lưu
};

const isInLocalStorage = (id: number) => {
  return storedVocabularyIds.value.includes(id);
};

const state = ref({
  checkAll: false,
  indeterminate: false,
});

const onCheckAllChange = (e: any) => {
  const checked = e.target.checked;
  state.value.checkAll = checked;
  state.value.indeterminate = false;

  if (checked) {
    // Thêm tất cả từ vựng vào localStorage
    const existingWords = JSON.parse(
      localStorage.getItem("selected_vocabularies") || "[]"
    );
    const newWords =
      props.vocabularyList?.filter(
        (word) =>
          !existingWords.some((existing: any) => existing.id === word.id)
      ) || [];

    if (newWords.length > 0) {
      const updatedWords = [...existingWords, ...newWords];
      localStorage.setItem(
        "selected_vocabularies",
        JSON.stringify(updatedWords)
      );
    }
  } else {
    // Xóa tất cả từ vựng trong bảng hiện tại khỏi localStorage
    const existingWords = JSON.parse(
      localStorage.getItem("selected_vocabularies") || "[]"
    );
    const wordIdsToRemove = props.vocabularyList?.map((word) => word.id) || [];
    const updatedWords = existingWords.filter(
      (word: any) => !wordIdsToRemove.includes(word.id)
    );

    localStorage.setItem("selected_vocabularies", JSON.stringify(updatedWords));
  }

  // Cập nhật danh sách từ vựng đã lưu
  loadStoredVocabularies();
};

// Cập nhật trạng thái checkbox khi danh sách từ vựng thay đổi
watch(
  () => props.vocabularyList,
  () => {
    if (props.vocabularyList) {
      const allInStorage = props.vocabularyList.every((word) =>
        isInLocalStorage(word.id!)
      );
      const someInStorage = props.vocabularyList.some((word) =>
        isInLocalStorage(word.id!)
      );

      state.value.checkAll = allInStorage;
      state.value.indeterminate = someInStorage && !allInStorage;
    }
  },
  { immediate: true }
);

onMounted(() => {
  loadStoredVocabularies();
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _cache[5] || (_cache[5] = _createElementVNode("th", { class: "px-4 py-2 text-left font-bold" }, "WORD", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("th", { class: "px-4 py-2 text-left font-bold" }, "TRANSLATE", -1)),
          (__props.isSelectPractice)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
                _createVNode(_component_a_checkbox, {
                  checked: state.value.checkAll,
                  "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((state.value.checkAll) = $event)),
                  indeterminate: state.value.indeterminate,
                  onChange: onCheckAllChange
                }, null, 8, ["checked", "indeterminate"])
              ]))
            : (_openBlock(), _createElementBlock("th", _hoisted_5))
        ])
      ]),
      (!__props.isSelectPractice)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.vocabularyList, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: record.id || index,
                onClick: ($event: any) => (handleRowClick(record)),
                class: _normalizeClass(["cursor-pointer bg-opacity-50 transition-all duration-300 hover:bg-gray-300", [
            selectedVocabulary.value?.id == record.id ? 'bg-gray-300' : null,
            index % 2 === 0 ? 'bg-gray-100' : 'bg-white',
          ]])
              }, [
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(record.english?.toLocaleUpperCase()), 1),
                  _createElementVNode("p", {
                    id: "MARK_STAR",
                    onClick: [
                      _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                      ($event: any) => (record.id !== undefined && handleChangeSpecial(record))
                    ]
                  }, [
                    _withDirectives(_createVNode(_unref(StarFilled), { class: "text-yellow-300 text-xl flex items-center hover:text-yellow-200" }, null, 512), [
                      [_vShow, record.is_special]
                    ]),
                    _withDirectives(_createVNode(_unref(StarOutlined), { class: "text-gray-300 text-xl flex items-center hover:text-gray-900" }, null, 512), [
                      [_vShow, !record.is_special]
                    ])
                  ], 8, _hoisted_10)
                ]),
                _createElementVNode("td", _hoisted_11, _toDisplayString(record.translate?.toLocaleUpperCase()), 1),
                _createElementVNode("td", _hoisted_12, [
                  _createVNode(_unref(Dropdown), {
                    trigger: "click",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_unref(Menu), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Menu).Item, {
                            key: "edit",
                            onClick: ($event: any) => (handleEdit(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(i18n).global.t("btn.edit")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_unref(Menu).Item, { key: "delete" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_popconfirm, {
                                cancelText: _unref(i18n).global.t('btn.cancel'),
                                okText: _unref(i18n).global.t('btn.confirm'),
                                onConfirm: ($event: any) => (handleDelete(record))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(QuestionCircleOutlined), { style: {"color":"red"} })
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(i18n).global.t("btn.delete")), 1)
                                ]),
                                _: 2
                              }, 1032, ["cancelText", "okText", "onConfirm"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_13, [
                        _createVNode(_unref(EllipsisOutlined))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 10, _hoisted_7))
            }), 128)),
            (!__props.vocabularyList || _unref(getLoadingGet)())
              ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(i18n).global.t("loading.default")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.vocabularyList, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: record.id || index,
                class: _normalizeClass(["cursor-pointer bg-opacity-50 transition-all duration-300", [isInLocalStorage(record.id!) ? 'bg-blue-600 bg-opacity-20' : null]]),
                onClick: _withModifiers(($event: any) => (toggleVocabularyInStorage(record)), ["stop"])
              }, [
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(record.english?.toLocaleUpperCase()), 1)
                ]),
                _createElementVNode("td", _hoisted_21, _toDisplayString(record.translate?.toLocaleUpperCase()), 1),
                _createElementVNode("td", _hoisted_22, [
                  _createVNode(_unref(Dropdown), {
                    trigger: "click",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_unref(Menu), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Menu).Item, {
                            key: "edit",
                            onClick: ($event: any) => (handleEdit(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(i18n).global.t("btn.edit")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_unref(Menu).Item, { key: "delete" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_popconfirm, {
                                cancelText: _unref(i18n).global.t('btn.cancel'),
                                okText: _unref(i18n).global.t('btn.confirm'),
                                onConfirm: ($event: any) => (handleDelete(record))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(QuestionCircleOutlined), { style: {"color":"red"} })
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(i18n).global.t("btn.delete")), 1)
                                ]),
                                _: 2
                              }, 1032, ["cancelText", "okText", "onConfirm"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_23, [
                        _createVNode(_unref(EllipsisOutlined))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 10, _hoisted_18))
            }), 128)),
            (!__props.vocabularyList || _unref(getLoadingGet)())
              ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                  _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(i18n).global.t("loading.default")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(PaginationComponent, {
      pageInfo: __props.pageInfo,
      onPageChange: handlePageChange,
      onPageSizeChange: handlePageSizeChange
    }, null, 8, ["pageInfo"]),
    (drawerVisible.value)
      ? (_openBlock(), _createBlock(DrawerVocaDetail, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (drawerVisible.value = false)),
          onEdit: handleEdit,
          drawerVisible: drawerVisible.value,
          vocabulary: selectedVocabulary.value !== null ? selectedVocabulary.value : {} as IVocabulary
        }, null, 8, ["drawerVisible", "vocabulary"]))
      : _createCommentVNode("", true)
  ]))
}
}

})